import { render } from "./roomDetail.vue?vue&type=template&id=61866e9b&scoped=true"
import script from "./roomDetail.vue?vue&type=script&lang=js"
export * from "./roomDetail.vue?vue&type=script&lang=js"

import "./roomDetail.vue?vue&type=style&index=0&id=61866e9b&lang=scss&scoped=true"
import "./roomDetail.vue?vue&type=style&index=1&id=61866e9b&lang=scss"
script.render = render
script.__scopeId = "data-v-61866e9b"

export default script